module.exports = __webpack_public_path__ + "bin/img/home_section02_visual.b1a6989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_section02_visual.svg
// module id = daW4
// module chunks = 1